import {
  CombinedCondition,
  FilterModel,
} from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";

import { isCombinedCondition } from "@app/util/viewModel/assert";

import { OPERATORS_ALLOWING_EMPTY_VALUE } from "./consts";

const doesNewCombinedConditionHasIncompleteValue = (condition: CombinedCondition): boolean => {
  // iterate over all filters and find those which have no value...
  return condition.conditions.some((condition) => {
    if (isCombinedCondition(condition)) {
      return doesNewCombinedConditionHasIncompleteValue(condition);
    } else {
      // Otherwise it's a simple condition

      // ...except when operator is one of OPERATORS_ALLOWING_EMPTY_VALUE since these
      // operators naturally support no value
      return (
        !OPERATORS_ALLOWING_EMPTY_VALUE.includes(condition.operator) &&
        (condition.value === undefined ||
          (Array.isArray(condition.value) && !condition.value.length))
      );
    }
  });
};

// returns true if there is at least one condition with no value, which probably indicates
// that user just added a new field and it has no value yet (or changed field or changed operator)
export const doesFilterModelHaveIncompleteValues = (filterModel: FilterModel): boolean => {
  return doesNewCombinedConditionHasIncompleteValue(filterModel);
};
